import React, { useState, useEffect } from 'react';
import '../styles/CookieConsent.css';

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
   
    const consentGiven = localStorage.getItem('cookieConsent');
    if (consentGiven) {
      setIsVisible(false); 
    }
  }, []);

  const handleAccept = () => {
    setIsVisible(false);
    localStorage.setItem('cookieConsent', 'true'); 
  };

  return (
    isVisible && (
      <div className="cookie-consent">
        <p>
          This website uses cookies to ensure you get the best experience on our website. 
          By continuing to browse, you consent to the use of cookies. 
        </p>
        <button onClick={handleAccept}>Got it!</button>
      </div>
    )
  );
}

export default CookieConsent;
